import styled from "styled-components"
import { LIGHT_GREY } from "../constants/colors"

export const Divider = styled.hr<{ margin?: string }>`
  height: 1px;
  background-color: ${LIGHT_GREY};
  margin: ${p => p.margin ?? "2rem 0"};
`
